import React from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';

const NavContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 16px;
`;

const NavButton = styled.button<{ $active?: boolean }>`
  background: transparent;
  border: none;
  color: ${props => (props.$active ? '#10b981' : 'rgba(255, 255, 255, 0.65)')};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  cursor: pointer;
`;

const SentryAgentBottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const isWallet = path.startsWith('/sentry-agent/wallet');
  const isStrategy = path.startsWith('/sentry-agent/strategy');

  return (
    <NavContainer>
      <NavButton type="button" $active={isWallet} onClick={() => navigate('/sentry-agent/wallet')}>
        Wallet
      </NavButton>
      <NavButton type="button" $active={isStrategy} onClick={() => navigate('/sentry-agent/strategy')}>
        Strategy
      </NavButton>
    </NavContainer>
  );
};

export default SentryAgentBottomNav;
